import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export const paragraphVariants = cva('text-sm flex items-center gap-2 dark:text-dark-input-label', {
	variants: {
		variant: {
			gray: 'text-gray-500 dark:text-muted-foreground',
			red: 'text-red-500',
			blue: 'text-blue-500',
			green: 'text-green-500',
			black: 'text-light-input-label',
		},
		size: {
			sx: 'text-xs',
			sm: 'text-sm',
			md: 'text-base',
			lg: 'text-lg',
			xl: 'text-xl',
		},
		weight: {
			normal: 'font-normal',
			bold: 'font-bold',
			medium: 'font-medium',
			semibold: 'font-semibold',
		},
	},
	defaultVariants: {
		variant: 'black',
		size: 'sm',
		weight: 'normal',
	},
});

export interface ParagraphModalProps
	extends React.HTMLAttributes<HTMLParagraphElement>,
		VariantProps<typeof paragraphVariants> {}

export const Paragraph = React.forwardRef<HTMLParagraphElement, ParagraphModalProps>(
	({ className, variant, size, weight, ...props }, ref) => {
		return (
			<p
				className={cn(paragraphVariants({ variant, size, weight, className }))}
				ref={ref}
				{...props}
			/>
		);
	},
);

Paragraph.displayName = 'ParagraphModal';
